export default "__VITE_ASSET__DVVfyyp5__"